import { useCallback, useState } from 'react';

export type RequestFilters = {
  account_id: number[];
  status: string[];
  cargo_type: string[];
  is_freighter_required: string | null;
  is_known_shipper: string | null;
  request_classification: string | null;
  account_type: string[];
  weight_break: number;
  payment_status: string[];
  shipment_status: string[];
  tenant_id: string[];
};

export const defaultRequestFilters = {
  account_id: [],
  account_type: [],
  status: [],
  cargo_type: [],
  is_freighter_required: null,
  is_known_shipper: null,
  request_classification: null,
  weight_break: null,
  payment_status: [],
  shipment_status: [],
  tenant_id: [],
} satisfies RequestFilters;

export const useRequestFilters = () => {
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState(defaultRequestFilters);

  const handleCheckboxFilterChange = (key: string) => (nextValue: string[]) => {
    setPage(1);
    setFilters((prev) => ({ ...prev, [key]: nextValue }));
  };

  const handleToggleAll = (key: string, value: string) => {
    setPage(1);
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleRadioFilterChange = (key: string) => (nextValue: string) => {
    setPage(1);
    setFilters((prev) => ({ ...prev, [key]: nextValue }));
  };

  const resetFilters = () => {
    setFilters(defaultRequestFilters);
  };

  const resetSingleFilter = (key: keyof typeof filters) => {
    setFilters({
      ...filters,
      [key]: Array.isArray(filters[key]) ? ([] as any) : null,
    });
  };

  const incrementPage = useCallback(() => {
    setPage((page) => page + 1);
  }, [setPage]);

  return {
    query,
    setQuery,
    page,
    setPage,
    incrementPage,
    filters,
    handleCheckboxFilterChange,
    handleRadioFilterChange,
    handleToggleAll,
    resetFilters,
    resetSingleFilter,
  };
};
